var _defs, _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ":root>g{display:none;}:root>g:target{display:inline;}"), /*#__PURE__*/React.createElement("path", {
    id: "hpLogo",
    d: "M48 96a49.7 49.7 0 0 1-1.426-.022l9.809-26.96h13.5c2.37 0 4.97-1.821 5.781-4.047L86.307 35.74c1.74-4.786-1-8.702-6.093-8.702H61.485L45.771 70.22h-.006l-8.909 24.478C15.721 89.672 0 70.673 0 48 0 25.981 14.827 7.427 35.04 1.772l-9.192 25.265h-.002L10.564 69.018l10.173.001 12.996-35.673h7.646L28.383 69.019l10.169.002 12.11-33.282c1.742-4.786-.999-8.702-6.087-8.702h-8.551L45.843.05C46.558.02 47.277 0 48 0c26.51 0 48 21.49 48 48S74.51 96 48 96Zm29.043-62.68h-7.644L58.697 62.688h7.643L77.043 33.32Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "multicolor-onLight",
    fill: "#0096D6"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#hpLogo"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "multicolor-onDark",
    fill: "#0096D6"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#hpLogo"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "singlecolor-onLight",
    fill: "black"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#hpLogo"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "singlecolor-onDark",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#hpLogo"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHp);
export default __webpack_public_path__ + "static/media/hp.33cb231970f14a2ff6774882c2d3287a.svg";
export { ForwardRef as ReactComponent };